import * as React from "react";
const SvgTopHalfLine = (props) => /* @__PURE__ */ React.createElement("svg", { width: 2, preserveAspectRatio: "none", viewBox: "0 0 2 32", className: "t-line", ...props }, /* @__PURE__ */ React.createElement("line", { x1: 1, y1: 0, x2: 1, y2: 16, stroke: "black", strokeWidth: 2 }));
export default SvgTopHalfLine;
